<template>
  <!--  h-offset v-offset blur spread color |inset|initial|inherit;-->
  <div class="form-group pt-1">
    <!--    <label class="custom-label" style="width: 100%" v-if="name">{{labelDesc}}</label>-->
    <div class="form p-0 m-0 position-relative w-100 d-flex">
      <div class="left-radius">
        <label style="width: 100%">
          <input
            type="number"
            :min="min"
            :max="max"
            class="custom-input form-control"
            v-model="v1"
            @change="changeValue"
            @keydown="keydownBlockNegative($event)"
            @keypress="changeValue"
            @mouseover="changeValue"
          />
          <div class="example-radius top-left"></div>
        </label>
        <label style="width: 100%">
          <input
            type="number"
            :min="min"
            :max="max"
            class="custom-input form-control"
            v-model="v4"
            @change="changeValue"
            @keydown="keydownBlockNegative($event)"
            @keypress="changeValue"
            @mouseover="changeValue"
            :disabled="linked"
          />
          <div class="example-radius bot-left"></div>
        </label>
      </div>
      <div class="right-radius">
        <label style="width: 100%">
          <div class="example-radius top-right"></div>
          <input
            type="number"
            :min="min"
            :max="max"
            class="custom-input form-control"
            v-model="v2"
            @change="changeValue"
            @keydown="keydownBlockNegative($event)"
            @keypress="changeValue"
            @mouseover="changeValue"
            :disabled="linked"
          />
        </label>
        <label style="width: 100%">
          <div class="example-radius bot-right"></div>
          <input
            type="number"
            :min="min"
            :max="max"
            class="custom-input form-control"
            v-model="v3"
            @change="changeValue"
            @keydown="keydownBlockNegative($event)"
            @keypress="changeValue"
            @mouseover="changeValue"
            :disabled="linked"
          />
        </label>
      </div>
      <button
        class="btn p-1"
        :class="[linked ? 'btn-danger' : 'btn-primary']"
        @click="linkWidth"
      >
        <i class="svg-icon svgi-link m-0"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BorderRadiusComponent",
  props: ["name"],
  data() {
    return {
      element: null,
      v1: "0",
      v2: "0",
      v3: "0",
      v4: "0",
      labelDesc: "border-radius",
      callback: null,
      min: 0,
      max: 100,
      linked: false,
    };
  },
  methods: {
    linkWidth() {
      this.linked = !this.linked;

      this.changeValue();
    },
    keydownBlockNegative(e) {
      if (e.keyCode == 189) {
        e.preventDefault();
        return false;
      }

      if (
        !(
          (e.keyCode > 95 && e.keyCode < 106) ||
          (e.keyCode > 47 && e.keyCode < 58) ||
          e.keyCode == 8
        )
      ) {
        return false;
      }
    },
    changeValue() {
      if (this.v1 < this.min) this.v1 = this.min;
      if (this.v2 < this.min) this.v2 = this.min;
      if (this.v3 < this.min) this.v3 = this.min;
      if (this.v4 < this.min) this.v4 = this.min;

      if (this.linked) {
        this.v1 = this.v1;
        this.v2 = this.v1;
        this.v3 = this.v1;
        this.v4 = this.v1;
      }

      document.body.style.setProperty(
        "--border-top-left-radius-example",
        this.v1 + "px"
      );
      document.body.style.setProperty(
        "--border-top-right-radius-example",
        this.v2 + "px"
      );
      document.body.style.setProperty(
        "--border-bottom-right-radius-example",
        this.v3 + "px"
      );
      document.body.style.setProperty(
        "--border-bottom-left-radius-example",
        this.v4 + "px"
      );

      let response = {
        value: `${this.v1}px ${this.v2}px ${this.v3}px ${this.v4}px`,
      };
      this.callback(response);
    },
    setValues(obj) {
      if (typeof obj.defaultValue === "undefined") {
        obj.defaultValue = "0 0 0 0";
      }

      let value = obj.defaultValue.split(" ");

      this.v1 = parseInt(value[0]);
      this.v4 = parseInt(value[3]);
      this.v2 = parseInt(value[1]);
      this.v3 = parseInt(value[2]);

      if (this.v1 == this.v2 && this.v1 == this.v3 && this.v1 == this.v4) {
        this.linked = true;
      }

      this.min = parseInt(obj.min);
      this.max = parseInt(obj.max);

      this.element = obj.element;
      this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
      this.callback = obj.callback;

      document.body.style.setProperty(
        "--border-top-left-radius-example",
        this.v1 + "px"
      );
      document.body.style.setProperty(
        "--border-top-right-radius-example",
        this.v2 + "px"
      );
      document.body.style.setProperty(
        "--border-bottom-right-radius-example",
        this.v3 + "px"
      );
      document.body.style.setProperty(
        "--border-bottom-left-radius-example",
        this.v4 + "px"
      );
    },
  },
};
</script>

<style scoped lang="scss">
.form-group {
  overflow: hidden;
}

.custom-input {
  width: 75px;
  display: inline-flex;
}

.right-radius,
.left-radius {
  display: flex;
  flex-direction: column;
}

.left-radius label,
.right-radius label {
  display: flex;

  input {
    flex: 2;
    min-width: 55px;
  }

  div {
    flex: 1;
    min-width: 35px;
  }
}

.left-radius .custom-input {
  margin-right: 10px;
}

.right-radius .custom-input {
  margin-left: 10px;
}

.example-radius {
  width: 38px;
  height: 32px;
  display: inline-flex;
}

.top-left {
  border-top: 1px solid black;
  border-left: 1px solid black;
  padding-top: 22px;
  margin-bottom: -8px;
  border-top-left-radius: var(--border-top-left-radius-example);
}

.top-right {
  border-top: 1px solid black;
  border-right: 1px solid black;
  padding-top: 22px;
  margin-bottom: -8px;
  border-top-right-radius: var(--border-top-right-radius-example);
}

.bot-left {
  border-bottom: 1px solid black;
  border-left: 1px solid black;
  padding-bottom: 22px;
  margin-bottom: -10px;
  border-bottom-left-radius: var(--border-bottom-left-radius-example);
}

.bot-right {
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  padding-bottom: 22px;
  margin-bottom: -10px;
  border-bottom-right-radius: var(--border-bottom-right-radius-example);
}

.btn {
  min-height: 5px !important;
  height: min-content;
  top: 28px;
  left: 109px;
  position: absolute;
  .svg-icon {
    filter: brightness(5);
  }
}
</style>





// WEBPACK FOOTER //
// src/components/editor/resource_components/BorderRadius.vue